import { Button, ButtonProps, Icon } from "@chakra-ui/react";
import { MdDownload } from "react-icons/md";

export const EXPORT_BUTTON_PROPS = {
  textTransform: "none",
  fontFamily: "body",
  fontWeight: "inherit",
  size: "xs",
  color: "gray.600",
  height: `${1.0835 * 1.5}rem`,
} as const;

export default function ExportButton({
  children = "Export",
  ...rest
}: ButtonProps) {
  return (
    <Button
      {...EXPORT_BUTTON_PROPS}
      leftIcon={<Icon as={MdDownload} />}
      loadingText="Exporting…"
      {...rest}
    >
      {children}
    </Button>
  );
}
